import React from 'react';

function PartsExplorer() {
  return <div>This is the parts explorer page</div>;
}

export default PartsExplorer;
